import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'app-mmax-end-line',
  templateUrl: './mmax-end-line.component.html',
  styleUrls: ['./mmax-end-line.component.scss']
})

export class MmaxEndLineComponent implements OnInit, OnDestroy {
  @Input('mode') modo: string;
  countdown: number = 5;
  private timerInterval: any;

  constructor(private serv: MarianomGeneral, private router: ActivatedRoute) {
    this.modo = this.modo || 'normal';
  }

  ngOnInit(): void {
    this.disableBack();
    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    });
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startCountdown() {
    this.timerInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timerInterval);
        this.volverAchan();
      }
    }, 1000);
  }

  disableBack() {
    window.onhashchange = function () {
      //console.log(window.location.hash);

      if (window.location.hash === "#/checkout/finalizar") {
        window.location.hash = "#/checkout/finalizado";
      }
    }
  }

  volverAchan() {
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.serv.navigator.goLandPage(this.router);
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }
}
